export var HOLDING_REPORT = "HOLDING_REPORT";
export var HOLDING_STREAM = "HOLDING_STREAM";
export var HOLDING_ERROR = "HOLDING_ERROR";
export var HOLDING_LOADER = "HOLDING_LOADER";
export var DP_TRANSACTION_HISTORY_HOLDING = "DP_TRANSACTION_HISTORY_HOLDING";
export var DP_IDS_HOLDING = "DP_IDS_HOLDING";
export var DP_TRANSACTION_HISTORY_LOADER = "DP_TRANSACTION_HISTORY_LOADER";
export var EMPTY_DP_TRANSACTION_VALIDATION = "EMPTY_DP_TRANSACTION_VALIDATION";
export var DP_TRANSACTION_MAIN_LOADER = "DP_TRANSACTION_MAIN_LOADER";
export var HIDE_EMPTY_DP_TRANSACTION_VALIDATION = "HIDE_EMPTY_DP_TRANSACTION_VALIDATION";
export var HOLDING_HIDE_ERROR = "HOLDING_HIDE_ERROR";
export var HOLDING_DOWNLOAD_STATUS = "HOLDING_DOWNLOAD_STATUS";
export var HOLDING_EMPTY_VALIDATION = "HOLDING_EMPTY_VALIDATION";
export var HOLDING_HIDE_EMPTY_VALIDATION = "HOLDING_HIDE_EMPTY_VALIDATION";
export var PROD_ASSET_FILTER_VAL_HOLDING = "PROD_ASSET_FILTER_VAL_HOLDING";
export var SAVE_SMTF = "SAVE_SMTF";
